import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { MatSelectChange } from "@angular/material/select";
import { TagType } from "@vp/models";
import { BehaviorSubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "vp-tag-type-selector",
  standalone: false,
  templateUrl: "./tag-type-selector.component.html",
  styleUrls: ["./tag-type-selector.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagTypeSelectorComponent implements OnInit {
  @Input() multiple = false;
  @Input() availableTagTypes!: TagType[];

  @Output() changedEvent = new EventEmitter<TagType[]>();

  formControl = new UntypedFormControl("", Validators.required);

  private readonly destroyed$ = new Subject<void>();
  private readonly selectedTagTypes$ = new BehaviorSubject<TagType[]>([]);

  ngOnInit(): void {
    this.formControl.markAllAsTouched();
    this.selectedTagTypes$.pipe(takeUntil(this.destroyed$)).subscribe(selected => {
      this.changedEvent.emit(selected);
    });
    if (this.availableTagTypes.length === 1) {
      this.formControl.patchValue(this.availableTagTypes[0]);
      this.selectedTagTypes$.next([this.availableTagTypes[0]]);
    }
  }

  selectionChanged(event: MatSelectChange) {
    if (this.multiple) {
      this.selectedTagTypes$.next([...event.value]);
    } else {
      this.selectedTagTypes$.next([event.value]);
    }
  }
}
